import { Layout } from "antd";

import { useGetLocation } from "@/entities/location";
import { PageItemContextGate } from "@/modules/page-item-context-gate";
import { useIdParam } from "@/services/router";

import { LocationPageHeader } from "./location-page-header";
import { LocationPageTabs } from "./location-page-tabs";

const { Content } = Layout;

export const LocationPage = () => {
  const id = useIdParam();
  const { isLoading, location, context, error } = useGetLocation(id);

  return (
    <PageItemContextGate
      model="location"
      itemContext={context}
      queryError={error}
    >
      <LocationPageHeader location={location} loading={isLoading} />
      <Content>
        <LocationPageTabs location={location} loading={isLoading} />
      </Content>
    </PageItemContextGate>
  );
};

export default LocationPage;
